import { render, staticRenderFns } from "./AssembleiaCard.vue?vue&type=template&id=6b21e049&"
import script from "./AssembleiaCard.vue?vue&type=script&lang=js&"
export * from "./AssembleiaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports